/**
 * The eight plant categories of FR-04, as data.
 *
 * The order is the order they were approved in, and it is the order the shelves
 * render — a category list that re-sorts itself by how many plants happen to be
 * in it makes the page move under the user's thumb between builds.
 *
 * `herbs-edibles` and `climbers` have no content packs yet (SPEC-002). They stay
 * declared, because the taxonomy is the approved one and a pack could fill them
 * tomorrow. Nothing offers them to a user in the meantime: `buildCategoryRails`
 * grows no shelf for an empty category and `listFilterGroups` offers no option
 * that cannot return a plant.
 */

export const PLANT_CATEGORIES = [
    { key: 'trees', messageKey: 'plants.category.trees' },
    { key: 'shrubs', messageKey: 'plants.category.shrubs' },
    { key: 'perennials', messageKey: 'plants.category.perennials' },
    { key: 'grasses', messageKey: 'plants.category.grasses' },
    { key: 'herbs-edibles', messageKey: 'plants.category.herbsEdibles' },
    { key: 'climbers', messageKey: 'plants.category.climbers' },
    { key: 'rock-dry-garden', messageKey: 'plants.category.rockDryGarden' },
    { key: 'groundcovers', messageKey: 'plants.category.groundcovers' },
];

export const CATEGORY_KEYS = PLANT_CATEGORIES.map((category) => category.key);

export function findCategory(categoryKey) {
    return PLANT_CATEGORIES.find((category) => category.key === categoryKey) || null;
}

export function isCategoryKey(candidate) {
    return CATEGORY_KEYS.includes(candidate);
}
